import { useNavigate } from "react-router-dom";
import AvailabilityRing, { getAvailLabel, getAvailClass } from "./AvailabilityRing";

const IMG_BASE = "https://api.firmconnector.com/";
const AC = (v) => v >= 30 ? "#16A34A" : v >= 10 ? "#D97706" : "#DC2626";

export default function CandidateCard({ candidate: r, onView }) {
  const navigate   = useNavigate();
  const avail      = Number(r.availability) || 0;
  const availColor = AC(avail);
  const availLabel = getAvailLabel(avail);
  const handleView = onView ? () => onView(r) : () => navigate(`/resources/details/${r.id}`);
  const skills     = Array.isArray(r.skills) ? r.skills : [];
  const hasImg     = !!(r.profile_image_path || r.image);

  return (
    <div onClick={handleView}
      style={{ padding:"12px 16px", cursor:"pointer", display:"flex", alignItems:"center", gap:12, transition:"background 0.1s" }}
      onMouseEnter={e=>e.currentTarget.style.background="#F8FAFC"}
      onMouseLeave={e=>e.currentTarget.style.background="transparent"}>

      {/* Avatar */}
      <div style={{ width:40, height:40, borderRadius:99, background:r.color+"15", border:`1.5px solid ${r.color}25`, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, overflow:"hidden" }}>
        {hasImg
          ? <img src={IMG_BASE+(r.profile_image_path||r.image)} alt="" style={{ width:"100%", height:"100%", objectFit:"cover" }} onError={e=>e.target.style.display="none"} />
          : <i className="fa-solid fa-user" style={{ fontSize:15, color:"#9CA3AF" }} />
        }
      </div>

      {/* Info */}
      <div style={{ flex:1, minWidth:0 }}>
        {/* Row 1: name + availability */}
        <div style={{ display:"flex", alignItems:"center", gap:7, marginBottom:(r.role||r.location||skills.length>0)?2:0 }}>
          <span style={{ fontSize:13, fontWeight:700, color:"#111827", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{r.name}</span>
          <span style={{ fontSize:10, fontWeight:700, padding:"1px 7px", borderRadius:99, background:availColor+"15", color:availColor, flexShrink:0 }}>
            {availLabel}
          </span>
        </div>

        {/* Row 2: role · location — only if content exists */}
        {(r.role || r.location) && (
          <div style={{ fontSize:11, color:"#6B7280", marginBottom:skills.length>0?5:0, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
            {[r.role, r.location].filter(Boolean).join("  ·  ")}
          </div>
        )}

        {/* Row 3: skills */}
        {skills.length > 0 && (
          <div style={{ display:"flex", gap:4, flexWrap:"wrap" }}>
            {skills.slice(0, 3).map(s => (
              <span key={s} style={{ fontSize:10, fontWeight:600, padding:"1px 7px", borderRadius:4, background:"#F3F4F6", color:"#374151", border:"1px solid #E5E7EB", whiteSpace:"nowrap" }}>{s}</span>
            ))}
            {skills.length > 3 && (
              <span style={{ fontSize:10, fontWeight:600, padding:"1px 7px", borderRadius:4, background:"#EFF6FF", color:"#2563EB", border:"1px solid #BFDBFE" }}>+{skills.length - 3}</span>
            )}
          </div>
        )}
      </div>

      {/* Availability ring */}
      <div style={{ flexShrink:0 }}>
        <AvailabilityRing value={avail} size={44} />
      </div>

      {/* View button */}
      <button onClick={e=>{ e.stopPropagation(); handleView(); }}
        style={{ height:28, padding:"0 12px", borderRadius:7, border:"1px solid #E5E7EB", background:"#fff", color:"#374151", fontSize:11, fontWeight:600, cursor:"pointer", fontFamily:"inherit", flexShrink:0, transition:"all 0.15s" }}
        onMouseEnter={e=>{ e.currentTarget.style.background="#EFF6FF"; e.currentTarget.style.borderColor="#BFDBFE"; e.currentTarget.style.color="#2563EB"; }}
        onMouseLeave={e=>{ e.currentTarget.style.background="#fff"; e.currentTarget.style.borderColor="#E5E7EB"; e.currentTarget.style.color="#374151"; }}>
        View
      </button>
    </div>
  );
}